export const knowledgeTreeStructure = {
  regulations: {
    id: 'regulations',
    name: '法规政策',
    description: '财政、会计、财管、税务相关法规',
    branches: [
      {
        id: 'finance',
        name: '财政法规',
        nodes: [
          { id: 'budget', name: '预算管理', articles: 45, subNodes: ['政府预算', '预算编制', '预算执行', '预算监督'] },
          { id: 'treasury', name: '国库管理', articles: 32, subNodes: ['国库集中支付', '资金管理', '账户管理'] },
          { id: 'transfer', name: '转移支付', articles: 28, subNodes: ['一般性转移支付', '专项转移支付'] },
          { id: 'debt', name: '政府债务', articles: 51, subNodes: ['地方政府债券', '债务管理', '风险防控'] }
        ]
      },
      {
        id: 'accounting',
        name: '会计准则',
        nodes: [
          { id: 'basic', name: '基本准则', articles: 67, subNodes: ['会计假设', '会计基础', '会计信息质量要求'] },
          { id: 'revenue', name: '收入准则', articles: 89, subNodes: ['收入确认', '合同成本', '特定交易'] },
          { id: 'lease', name: '租赁准则', articles: 54, subNodes: ['承租人会计', '出租人会计', '售后租回'] },
          { id: 'financial-instruments', name: '金融工具', articles: 76, subNodes: ['金融资产', '金融负债', '套期会计'] }
        ]
      },
      {
        id: 'management',
        name: '财务管理',
        nodes: [
          { id: 'internal-control', name: '内部控制', articles: 43, subNodes: ['控制环境', '风险评估', '控制活动'] },
          { id: 'cost-management', name: '成本管理', articles: 58, subNodes: ['成本核算', '成本控制', '成本分析'] },
          { id: 'performance', name: '绩效管理', articles: 39, subNodes: ['绩效评价', '预算绩效', 'KPI指标'] },
          { id: 'risk-management', name: '风险管理', articles: 47, subNodes: ['风险识别', '风险评估', '风险应对'] }
        ]
      },
      {
        id: 'tax',
        name: '税务法规',
        nodes: [
          { id: 'vat', name: '增值税', articles: 123, subNodes: ['税率调整', '进项抵扣', '出口退税', '优惠政策'] },
          { id: 'corporate-tax', name: '企业所得税', articles: 98, subNodes: ['应纳税所得额', '税前扣除', '优惠政策', '汇算清缴'] },
          { id: 'individual-tax', name: '个人所得税', articles: 87, subNodes: ['综合所得', '专项附加扣除', '年度汇算'] },
          { id: 'other-taxes', name: '其他税种', articles: 64, subNodes: ['印花税', '房产税', '土地增值税', '消费税'] }
        ]
      }
    ]
  },
  interpretation: {
    id: 'interpretation',
    name: '政策解读',
    description: '专业解读最新财税政策',
    branches: [
      {
        id: 'tax-policy',
        name: '税收政策解读',
        nodes: [
          { id: 'vat-interpretation', name: '增值税政策', articles: 34, subNodes: ['最新政策', '操作指南', '案例分析'] },
          { id: 'corporate-interpretation', name: '企业所得税政策', articles: 28, subNodes: ['研发费用', '资产损失', '税收优惠'] },
          { id: 'preferential', name: '税收优惠政策', articles: 27, subNodes: ['小微企业', '高新技术', '区域优惠'] }
        ]
      },
      {
        id: 'accounting-policy',
        name: '会计政策解读',
        nodes: [
          { id: 'new-standards', name: '新准则解读', articles: 31, subNodes: ['准则变化', '衔接规定', '实施影响'] },
          { id: 'application', name: '准则应用', articles: 23, subNodes: ['实务问题', '判断标准', '披露要求'] },
          { id: 'comparison', name: '准则比较', articles: 13, subNodes: ['新旧对比', '国际比较'] }
        ]
      },
      {
        id: 'finance-policy',
        name: '财政政策解读',
        nodes: [
          { id: 'fiscal-policy', name: '财政政策', articles: 25, subNodes: ['积极财政', '减税降费', '财政支出'] },
          { id: 'subsidy', name: '补贴政策', articles: 18, subNodes: ['企业补贴', '行业补贴', '申报流程'] },
          { id: 'reform', name: '财税改革', articles: 11, subNodes: ['改革方向', '影响分析'] }
        ]
      }
    ]
  },
  cases: {
    id: 'cases',
    name: '实务案例',
    description: '真实案例分析与实践',
    branches: [
      {
        id: 'tax-planning',
        name: '税务筹划案例',
        nodes: [
          { id: 'enterprise-planning', name: '企业税务筹划', articles: 56, subNodes: ['组织架构', '业务模式', '投资决策'] },
          { id: 'individual-planning', name: '个人税务筹划', articles: 34, subNodes: ['薪酬优化', '股权激励', '财产转让'] },
          { id: 'cross-border', name: '跨境税务筹划', articles: 28, subNodes: ['转让定价', '税收协定', '反避税'] },
          { id: 'restructuring', name: '重组并购筹划', articles: 27, subNodes: ['资产重组', '股权重组', '特殊性税务处理'] }
        ]
      },
      {
        id: 'audit',
        name: '审计案例',
        nodes: [
          { id: 'financial-audit', name: '财务报表审计', articles: 42, subNodes: ['审计程序', '重大错报', '审计意见'] },
          { id: 'internal-audit', name: '内部审计', articles: 31, subNodes: ['内控审计', '经济责任审计'] },
          { id: 'special-audit', name: '专项审计', articles: 25, subNodes: ['税务审计', '合规审计', '尽职调查'] }
        ]
      },
      {
        id: 'financial-analysis',
        name: '财务分析案例',
        nodes: [
          { id: 'ratio-analysis', name: '财务比率分析', articles: 38, subNodes: ['偿债能力', '盈利能力', '运营能力'] },
          { id: 'industry-analysis', name: '行业分析', articles: 35, subNodes: ['行业对比', '竞争分析', '趋势预测'] },
          { id: 'valuation', name: '企业估值', articles: 29, subNodes: ['估值方法', '价值评估', '投资决策'] },
          { id: 'risk-analysis', name: '风险分析', articles: 20, subNodes: ['财务风险', '经营风险', '风险预警'] }
        ]
      }
    ]
  },
  industry: {
    id: 'industry',
    name: '行业动态',
    description: '行业最新发展趋势',
    branches: [
      {
        id: 'industry-news',
        name: '行业新闻',
        nodes: [
          { id: 'policy-news', name: '政策动态', articles: 89, subNodes: ['最新政策', '政策解读', '影响分析'] },
          { id: 'market-news', name: '市场动态', articles: 76, subNodes: ['市场变化', '行业趋势', '企业动态'] },
          { id: 'tech-news', name: '技术创新', articles: 69, subNodes: ['数字化转型', '智能财税', '区块链应用'] }
        ]
      },
      {
        id: 'market-analysis',
        name: '市场分析',
        nodes: [
          { id: 'macro-analysis', name: '宏观经济分析', articles: 54, subNodes: ['经济形势', '政策影响', '发展预测'] },
          { id: 'industry-report', name: '行业研究报告', articles: 48, subNodes: ['行业现状', '竞争格局', '发展趋势'] },
          { id: 'data-analysis', name: '数据分析', articles: 54, subNodes: ['统计数据', '数据解读', '趋势分析'] }
        ]
      },
      {
        id: 'trend',
        name: '发展趋势',
        nodes: [
          { id: 'digital', name: '数字化趋势', articles: 37, subNodes: ['智能化', '自动化', '云计算'] },
          { id: 'regulation', name: '监管趋势', articles: 29, subNodes: ['合规要求', '监管政策', '风险防控'] },
          { id: 'international', name: '国际化趋势', articles: 23, subNodes: ['国际准则', '跨境业务', '全球化'] }
        ]
      }
    ]
  },
  news: {
    id: 'news',
    name: '最新资讯',
    description: '财税领域最新动态',
    branches: [
      {
        id: 'daily-news',
        name: '每日资讯',
        nodes: [
          { id: 'today', name: '今日要闻', articles: 156, subNodes: ['重要新闻', '政策发布', '行业动态'] },
          { id: 'weekly', name: '一周回顾', articles: 98, subNodes: ['本周要闻', '政策汇总', '市场回顾'] },
          { id: 'monthly', name: '月度总结', articles: 202, subNodes: ['月度政策', '行业报告', '数据统计'] }
        ]
      },
      {
        id: 'policy-update',
        name: '政策更新',
        nodes: [
          { id: 'new-policy', name: '新政发布', articles: 67, subNodes: ['最新法规', '政策文件', '实施时间'] },
          { id: 'policy-change', name: '政策变化', articles: 54, subNodes: ['修订内容', '变化对比', '影响分析'] },
          { id: 'notice', name: '通知公告', articles: 57, subNodes: ['官方通知', '征求意见', '答复函'] }
        ]
      },
      {
        id: 'hot-topic',
        name: '热点话题',
        nodes: [
          { id: 'focus', name: '焦点关注', articles: 89, subNodes: ['热点事件', '专题讨论', '深度分析'] },
          { id: 'qa', name: '热点问答', articles: 78, subNodes: ['常见问题', '专家解答', '实务指导'] },
          { id: 'discussion', name: '话题讨论', articles: 67, subNodes: ['行业观点', '专家评论', '用户讨论'] }
        ]
      }
    ]
  }
};